<template>
  <v-text-field
    :value="paso"
    type='text'
    :label="label"
    hide-details
    outlined
    dense
    :disabled="disabled"
  >
  </v-text-field>
</template>

<script>

export default {
  props: [
    'value',
    'label',
    'disabled',
    'ServiceClass',
    'displayField',
  ],

  data() {
    return {
      paso: '',
    };
  },

  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted() {
    const propertyService = new this.ServiceClass();
    propertyService.get(this.text)
      .then((response) => {
        this.paso = response.data[this.displayField];
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/InputDownloadComponent.vue